const ErrorBoundary = ({ children }) => children;

export default ErrorBoundary;
